import { SVGProps } from 'react'
import * as React from 'react'

const LecturesQtyIcon: React.FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="25"
      height="19"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.80435 0C3.80374 0 3.80306 0 3.80245 0C3.58928 0 3.38878 0.0862788 3.23738 0.243078C3.08431 0.40161 3 0.612698 3 0.837417V13.3943C3 13.8548 3.36222 14.2303 3.80754 14.2315C5.68488 14.2362 8.83018 14.6424 11 17V3.85883C11 3.70274 10.9616 3.55611 10.8891 3.43476C9.10824 0.457002 5.68594 0.00457002 3.80435 0Z"
        fill={props.color ? props.color : '#1A1E3D'}
      />
      <path
        d="M21 13.3944V0.837417C21 0.612698 20.9157 0.40161 20.7626 0.243078C20.6112 0.0862788 20.4106 0 20.1976 0C20.1969 0 20.1963 0 20.1956 0C18.3141 0.00464881 14.8918 0.457081 13.1108 3.43484C13.0383 3.55618 13 3.70282 13 3.85891V17C15.1698 14.6424 18.3152 14.2362 20.1925 14.2315C20.6378 14.2303 21 13.8548 21 13.3944Z"
        fill={props.color ? props.color : '#1A1E3D'}
      />
      <path
        d="M23.1534 3H22.5395V13.5107C22.5395 14.6877 21.5709 15.6475 20.3803 15.6504C18.7086 15.6544 15.9522 15.978 14 17.8074C17.3763 16.9889 20.9355 17.521 22.9639 17.9787C23.2172 18.0358 23.4789 17.9768 23.6818 17.8167C23.884 17.6569 24 17.4181 24 17.1619V3.83823C24.0001 3.37604 23.6202 3 23.1534 3Z"
        fill={props.color ? props.color : '#1A1E3D'}
      />
      <path
        d="M1.46053 13.5108V3H0.846585C0.379872 3 0 3.37605 0 3.83824V17.1618C0 17.4182 0.116001 17.6569 0.318206 17.8166C0.520969 17.9767 0.78245 18.0359 1.03612 17.9786C3.06455 17.5209 6.62386 16.9889 10 17.8074C8.0479 15.978 5.29144 15.6544 3.6197 15.6505C2.42917 15.6477 1.46053 14.6879 1.46053 13.5108Z"
        fill={props.color ? props.color : '#1A1E3D'}
      />
    </svg>
  )
}

export default LecturesQtyIcon
